import React from 'react';
import ReactSwitch from 'react-switch';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Grid
} from '@mui/material';

const CanvasPropertyInspector = ({ 
  canvasSize, 
  canvasProperties, 
  onSizeChange, 
  onPropertyChange 
}) => {
  const updateCanvasSize = (key, value) => {
    onSizeChange({
      ...canvasSize,
      [key]: value
    });
  };

  const updateCanvasProperty = (key, value) => {
    onPropertyChange({
      ...canvasProperties,
      [key]: value
    });
  };

  return (
    <Paper sx={{ height: '100%' }}>
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
          🎨 Canvas Properties
        </Typography>
        
        <Grid container spacing={2}>
          {/* Canvas Size */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>
              Canvas Size
            </Typography>
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              label="Width"
              type="number"
              value={canvasSize.width}
              onChange={(e) => updateCanvasSize('width', parseInt(e.target.value) || 100)}
              size="small"
              fullWidth
              InputProps={{ inputProps: { min: 100, max: 1920 } }}
            />
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              label="Height"
              type="number"
              value={canvasSize.height}
              onChange={(e) => updateCanvasSize('height', parseInt(e.target.value) || 100)}
              size="small"
              fullWidth
              InputProps={{ inputProps: { min: 100, max: 1080 } }}
            />
          </Grid>
          
          {/* Canvas Style */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
              Canvas Style
            </Typography>
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              label="Background Color"
              type="color"
              value={canvasProperties.backgroundColor}
              onChange={(e) => updateCanvasProperty('backgroundColor', e.target.value)}
              size="small"
              fullWidth
            />
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              label="Border Width"
              type="number"
              value={canvasProperties.borderWidth}
              onChange={(e) => updateCanvasProperty('borderWidth', parseInt(e.target.value) || 0)}
              size="small"
              fullWidth
              InputProps={{ inputProps: { min: 0, max: 10 } }}
            />
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              label="Border Color"
              type="color"
              value={canvasProperties.borderColor}
              onChange={(e) => updateCanvasProperty('borderColor', e.target.value)}
              size="small"
              fullWidth
            />
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              label="Border Radius"
              type="number"
              value={canvasProperties.borderRadius}
              onChange={(e) => updateCanvasProperty('borderRadius', parseInt(e.target.value) || 0)}
              size="small"
              fullWidth
              InputProps={{ inputProps: { min: 0, max: 50 } }}
            />
          </Grid>
          
          {/* Grid Settings */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
              Grid Settings
            </Typography>
          </Grid>
          
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ReactSwitch
                checked={canvasProperties.showGrid}
                onChange={(checked) => updateCanvasProperty('showGrid', checked)}
                onColor="#edbc45"
                offColor="#ccc"
                height={20}
                width={40}
                handleDiameter={16}
                uncheckedIcon={false}
                checkedIcon={false}
              />
              <Typography variant="body2">Show Grid</Typography>
            </Box>
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              label="Grid Size"
              type="number"
              value={canvasProperties.gridSize}
              onChange={(e) => updateCanvasProperty('gridSize', parseInt(e.target.value) || 10)}
              size="small"
              fullWidth
              InputProps={{ inputProps: { min: 5, max: 50 } }}
              disabled={!canvasProperties.showGrid}
            />
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              label="Grid Color"
              type="color"
              value={canvasProperties.gridColor}
              onChange={(e) => updateCanvasProperty('gridColor', e.target.value)}
              size="small"
              fullWidth
              disabled={!canvasProperties.showGrid}
            />
          </Grid>
          
          {/* Canvas Info */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
              Canvas Info
            </Typography>
          </Grid>
          
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              Total Size: {canvasSize.width} × {canvasSize.height} px
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Aspect Ratio: {(canvasSize.width / canvasSize.height).toFixed(2)}:1
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Grid Spacing: {canvasProperties.showGrid ? `${canvasProperties.gridSize}px` : 'Disabled'}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default CanvasPropertyInspector;